import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
  Badge,
} from "reactstrap"
import { ReactSearchAutocomplete } from "react-search-autocomplete"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as printAction from "../../../store/cHJpbnRPbkhvbGQ/actions"
import * as printPlAction from "../../../store/cHJpbnRQbFVuQXN/actions"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import moment from "moment"
import api from "helpers/Api"

const PrintPlOnHold = (props) => {
  const { dispatch, searchBtnStyle } = props

  const title = "Print On Hold"

  const [downloadLoading, setDownloadLoading] = useState(false)
  const empId = localStorage.getItem("empId")
  //Fetching API
  useEffect(() => {
    dispatch(printAction.loadRecordsMetaData())
    dispatch(
      printAction.loadPrint({
        page: 1,
        limit: 50,
        printProcessStatus: "PS74",
        PrintPlId: empId,
      })
    )
    dispatch(printAction.loadVendor({ status: "active" }))
  }, [])

  //date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""

  //Reducer state
  const { clientEvent_data = [] } = useSelector(
    (specificstate) => specificstate.printPlUnAssigned
  )

  const update = useSelector((specificstate) => specificstate.printOnHold)

  const { print_data = [], recordsMetaData = {}, vendor_data } = update

  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)


  const [btnLoader, setBtnLoader] = useState(false)

  const [productName, setProductName] = useState([])
  const [productCategoryName, setProductCategoryName] = useState([])
  const [crmName, setCrmName] = useState([])
  const [clearanceStatus, setClearanceStatus] = useState([])
  const [agentKey, setAgentKey] = useState(false)

  //printAssignToDate
  const [printData, setPrintData] = useState({
    printAssignFromDate: "",
    printAssignToDate: "",
  })
  //inprogress checkbox
  const [isPackageInclusion, setIsPackageInclusion] = useState("")

  const statusListEngage = [
    {
      label: "Is Package Inclusion",
      value: true,
    },
  ]

  const handleStatusEngageChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setIsPackageInclusion(value)
    } else {
      setIsPackageInclusion(false)
    }
  }

  const handleChange = (e) => {
    setPrintData({
      ...printData,
      [e.target.name]: e.target.value,
    })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
          printProcessStatus: "PS74",
          PrintPlId: empId,
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          printProcessStatus: "PS74",
          PrintPlId: empId,
          searchFilter: searchInput,
        }
  //Handle Filters
  const handleFilter = (e) => {
    e.preventDefault()
    var searchProduct = productName && productName ? productName.value : ""
    var searchProductCategory = productCategoryName && productCategoryName ? productCategoryName.value : ""
    var searchClearance = clearanceStatus && clearanceStatus ? clearanceStatus.value : ""
    var searchCrm = crmName && crmName ? crmName.value : ""
    var searchIsPackageInclusion = isPackageInclusion && isPackageInclusion == true ? true : ""
    var searchFromDate =
      printData && printData.printAssignFromDate
        ? moment(printData.printAssignFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      printData && printData.printAssignToDate
        ? moment(printData.printAssignToDate).format("YYYY-MM-DD")
        : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    searchvalue.printProcessStatus = 'PS74'
    searchvalue.PrintPlId = empId
    if (searchProduct) {
      searchvalue.productId = searchProduct
    }
    if (searchProductCategory) {
      searchvalue.productCategoryId = searchProductCategory
    }
    if (searchClearance) {
      searchvalue.paymentStatus = searchClearance
    }
    if (searchCrm) {
      searchvalue.crmPrintId = searchCrm
    }
    if (searchFromDate) {
      searchvalue.printAssignedFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.printAssignedToDate = searchToDate
    }
    if (searchIsPackageInclusion) {
      searchvalue.isPackageInclusion = searchIsPackageInclusion
    }
    setPageLoad(!pageLoad)

    setSearchValueList(searchvalue)
    dispatch(printAction.loadPrint(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)

    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  //vendor options
  const vendorOptions =
    !isEmpty(vendor_data) && vendor_data.length > 0
      ? vendor_data.map((data) => {
        return {
          label: data.printVendorCode + "-" + data.printVendorName,
          value: data._id,
        }
      })
      : []
  //reset

  const resetForm = () => {
    setSearchInput("")
    setPrintData({
      ...printData,
      printAssignFromDate: "",
      printAssignToDate: "",
    })
    setProductCategoryName([])
    setClearanceStatus([])
    setAgentKey(true)
    setProductName([])
    setCrmName([])
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setIsPackageInclusion(false)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
    }, 1000)
    setSearchValueList({
      page: 1,
      limit: 50,
      printProcessStatus: "PS74",
      PrintPlId: empId,
    })
    dispatch(
      printAction.loadPrint({
        page: 1,
        limit: 50,
        printProcessStatus: "PS74",
        PrintPlId: empId,
      })
    )
  }

  const [processData, setProcessData] = useState({
    notes: "",
  })
  const handleNotesChange = (e) => {
    setProcessData({ ...processData, [e.target.name]: e.target.value })
  }
  const [updateProcess, setUpdateProcess] = useState("")
  const [processStatusModal, setProcessStatusModal] = useState(false)

  const [operationAttachment, setOperationAttachment] = useState([])

  const operationAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setOperationAttachment(file)
      var teamUploadValue = operationAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setOperationAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const handleClearProcessModal = () => {
    setProcessData({
      ...processData,
      notes: "",
    })
    setOperationAttachment([])
    setDeliverableStatus([])
  }

  // columns data editable history details

  const [processHistoryDetails, setProcessHistoryDetails] = useState("")
  //
  const [teamData, setTeamData] = useState({
    note: "",
  })

  const handleTeam = (e) => {
    setTeamData({ ...teamData, [e.target.name]: e.target.value })
  }

  const [multiVendorEmployee, setMultiVendorEmployee] = useState([])

  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }
  const [vendorAssignModal, setVendorAssignModal] = useState(false)
  const [vendorAssignDetails, setVendorAssignDetails] = useState([])
  const [vendorAssignData, setVendorAssignData] = useState("")
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)
  const [multiVendorModal, setMultiVendorModal] = useState(false)
  const [vendorEmployee, setVendorEmployee] = useState([])

  //clear vendor modal
  const handleClearModal = () => {
    setTeamData({
      ...teamData,
      note: "",
    })
    setMultiTeamData({
      ...multiTeamData,
      note: "",
    })
    setVendorEmployee([])
    setMultiVendorEmployee([])
    setUploadModalInput([])
    setFileName("")
    setFileLength("")
    setMultiTeamFile([])
    setTeamFileName("")
    setTeamFileLength("")
  }
  //Deliverable status
  const [deliverableStatus, setDeliverableStatus] = useState([])
  const deliverableStatusOptions = [
    { label: "PV QUEUE", value: "PS49" },
    { label: "PRINT NOT APPLICABLE", value: "PS73" }
  ]
  //assigned history modal

  let slNo = 0
  const myWorksTable = !isEmpty(print_data)
    ? print_data.data.map((data, index) => {
      slNo = slNo + 1
      const colorCode =
        !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0
          ? recordsMetaData.processStatusOptions.find(
            (_) => _.value === data.printProcessstatus
          )?.colorCode
          : ""

      const plArray =
        !isEmpty(data.assignedPrintPl) &&
        data.assignedPrintPl.length > 0 &&
        data.assignedPrintPl
          .map((m) => {
            const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
            return empName
          })
          .filter(Boolean)
      const plName = plArray.length > 0 ? plArray.join(",") : "--"

      const employeeArray =
        !isEmpty(data.assignedEmployee) &&
        data.assignedEmployee.length > 0 &&
        data.assignedEmployee
          .map((m) => {
            const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
            return empName
          })
          .filter(Boolean)
      const employeeName =
        employeeArray.length > 0 ? employeeArray.join(",") : "--"
      const printVendorArray =
        !isEmpty(data.assignedPrintVendor) &&
        data.assignedPrintVendor.length > 0 &&
        data.assignedPrintVendor
          .map((m) => {
            const empName = !isEmpty(m)
              ? `${m.printVendorCode} - ${m.printVendorName}`
              : ""
            return empName
          })
          .filter(Boolean)
      const printVendorName =
        printVendorArray.length > 0 ? printVendorArray.join(",") : "--"

      const eventDate = data && data.eventDetails.length > 0 ?
        data.eventDetails.map(m => moment(m.eventDate).format(dateFormat)).join(",")
        : "--"
      const crmName = data && !isEmpty(data.assignedCrmEmployee) ? data.assignedCrmEmployee.map(m => m.name).join(",") : "--"

      const clearanceColorCode =
        !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0
          ? (data.clearanceStatus
            ? recordsMetaData.processStatusOptions.find(
              (option) => option.value === data.clearanceStatus
            )?.colorCode
            : recordsMetaData.processStatusOptions.find(
              (option) => option.label === data.clearanceStatusName
            )?.colorCode
          )
          : ""
      return {
        key: index,
        _id: data.leadId,
        sNo: slNo,
        colorCode: !isEmpty(colorCode) ? colorCode : "",
        leadNo: data.leadNo,
        company: data.companyName,
        branch: data.branchName,
        leadDeliverableId: data.leadDeliverableId,
        clientCode: data.clientCode ? data.clientCode : "--",
        clientName: data.clientName ? data.clientName : "--",
        productName:
          data.productName && !isEmpty(data.deliverableName)
            ? data.productName + `(${data.deliverableName})`
            : "--",
        operationId: data.operationId ? data.operationId : "--",
        quantity: data.quantity ? data.quantity : "--",
        remarks: data.ewRemark ? data.ewRemark : "--",
        crmRemarks: data.crmRemark ? data.crmRemark : "--",
        overallStatus: data.overAllStatus ? data.overAllStatus : "--",
        crmName: crmName,
        crmAttachments: data.crmAttachments ? data.crmAttachments : "",
        attachment: data.ewAttachments ? data.ewAttachments : "",
        tatDate: data.tat ? moment(data.tat).format(dateFormat) : "--",
        specialInstructions: data.specialInstruction
          ? data.specialInstruction
          : "--",

        instructions: data.specialInstruction
          ? data.specialInstruction.length
          : 0,
        productLeadName: plName,
        endWorkerName: employeeName,
        vendorName: (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-warning text-nowrap"
                onClick={() => {
                  setVendorAssignModal(true)
                  setVendorAssignData(data)
                  handleClearModal()
                }}
              >
                {!isEmpty(data.assignedPrintVendor) &&
                  data.assignedPrintVendor.length > 0
                  ? printVendorName
                  : "Vendor Assign"}
              </Button>

              <div className="ms-auto ml-2">
                <Input
                  type="checkbox"
                  checked={vendorAssignDetails.some(
                    (item) => item.operationId === data.operationId
                  )}
                  style={{
                    width: "15px",
                    height: "15px",
                    marginLeft: "10px",
                  }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !vendorAssignDetails.find(
                        (item) => item.operationId === data.operationId
                      )
                    ) {
                      setVendorAssignDetails([...vendorAssignDetails, data])
                    } else {
                      setVendorAssignDetails(
                        vendorAssignDetails.filter(
                          (item) => item.operationId !== data.operationId
                        )
                      )
                    }
                    const anyChecked = vendorAssignDetails.some(
                      (item) => item.operationId !== data.operationId
                    )
                    setTeamSubmitButton(anyChecked)
                  }}
                />
              </div>
            </div>
          </>
        ),
        link: data.link ? data.link : "--",
        operationStatus: data.productionprocessstatus
          ? data.productionprocessstatus
          : "",
        operationStatusName: data.productioProcessStatusName
          ? data.productioProcessStatusName
          : "",
        groomName: data.groomName ? data.groomName : "--",
        brideName: data.brideName ? data.brideName : "--",
        operationHistory: !isEmpty(data.operationalHistory)
          ? data.operationalHistory
          : [],
        processHistory: !isEmpty(data.assignedPrintPl)
          ? data.assignedPrintPl
          : [],
        assignedHistory: !isEmpty(data.assignedHistory)
          ? data.assignedHistory
          : [],
        printProcessStatusName: data.printProcessStatusName,
        printProcessStatus: data.printProcessstatus,
        menuMode: data.menuMode,
        printProcessHistory: !isEmpty(data.printProcessHistory)
          ? data.printProcessHistory
          : [],
        eventDate: eventDate,
        applicableEvents: !isEmpty(data.eventDetails) ? data.eventDetails.map(m => m.eventName).join(",") : "--",
        clearanceStatus: data.clearanceStatusName ? data.clearanceStatusName : "--",
        printAssignDate: data.printAssignDate
          ? moment(data.printAssignDate).format(dateFormat)
          : "--",
        packageInclusionNumber: data.packageInclusionNumber
          ? data.packageInclusionNumber
          : "--",
        sheetCount: (data.sheetLength !== null && data.sheetLength !== undefined &&
          data.count !== null && data.count !== undefined) ?
          `${data.sheetLength}/${data.count}` :
          "--",
        printFileLink: data.printFileLink ? data.printFileLink : "--",
        deliveryAddress: data.deliveryAddress ? data.deliveryAddress : "--",
        productRemarks: data.productRemarks ? data.productRemarks : "--",
        pvAssign: data.assignedPrintVendor && !isEmpty(data.assignedPrintVendor) ? data.assignedPrintVendor : [],
        dataDetails: data ? data : "",
        clearanceColorCode: clearanceColorCode ? clearanceColorCode : "",
        printDeliverableCode: data.printDeliverableCode ? data.printDeliverableCode : "--",
        "noOfSheets": data.noOfSheet || "--",
        "noOfWrapperSheets": data.noOfWrapperSheet || "--",
        //"productRemarks": data.additionalProductRemarks || "--",
        "packageInclusionRemarks": data.packageInclusionRemarks || "--",
      }
    })
    : []

  useEffect(() => {
    if (vendorAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [vendorAssignDetails])


  const [clientEventModal, setClientEventModal] = useState(false)

  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
      csvType: Number,
    },
    {
      dataField: "printDeliverableCode",
      text: "Print Deliverable Code",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "printAssignDate",
      text: "Print Assign Date",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "productRemarks",
      text: "Product Remarks",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "productName",
      text: "Product Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "sheetCount",
      text: "Sheet / Count",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "noOfSheets",
      text: "No Of Sheets",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "noOfWrapperSheets",
      text: "No Of Wrapper Sheets",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "crmName",
      text: "CRM Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "applicableEvents",
      text: "Applicable Events",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      editable: false,
      hidden: false,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      formatter: (cellContent, row) => {
        const payload = {
          clientNo: row.clientCode,
        }
        return (
          <div>
            {" "}
            <a
              onClick={() => {
                setClientEventModal(true)
                setTimeout(() => {
                  dispatch(printPlAction.loadClientEvent(payload))
                })
              }}
            >
              {cellContent}
            </a>
          </div>
        )
      },
    },
    {
      dataField: "productLeadName",
      text: "Print PL Name",
      hidden: true,
      editable: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "vendorName",
      text: "Vendor Name",
      editable: false,
      hidden: false,
      csvExport: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "packageInclusionNo",
      text: "Package Inclusion No",
      editable: false,
      hidden: false,
      csvExport: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "packageInclusionRemarks",
      text: "Package Inclusion Remarks",
      editable: false,
      hidden: false,
      csvExport: false,
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "printFileLink",
      text: "print File Link",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
      formatter: (cellContent) => (
        cellContent ? <a href={cellContent} target="_blank" rel="noopener noreferrer">{cellContent}</a> : "--"
      ),
    },

    {
      dataField: "deliveryAddress",
      text: "Delivery Address",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "quantity",
      text: "Quantity",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
    },

    {
      dataField: "printProcessStatus",
      text: "Deliverable Status",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {!isEmpty(row.printProcessStatusName) ? (
                <button
                  style={{
                    background: row.colorCode,
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "2px",
                    borderRadius: "4px",
                  }}
                >
                  {row.printProcessStatusName}
                </button>
              ) : (
                "--"
              )}
            </Col>
            <Col md="2" lg="2" sm="2">
              <button
                style={{
                  background: "#17b77d",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setVendorAssignData(row.dataDetails)
                  setUpdateProcess(row)
                  setProcessStatusModal(true)
                  handleClearProcessModal()
                  setProcessHistoryDetails(row.printProcessHistory)
                  handleClearModal()
                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clearanceStatus",
      text: "Clearnace Status",
      editable: false,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
      formatter: (cellContent, row) => {
        const paymentStatus = row.paymentStatus

        let badgeClassName = ""
        if (paymentStatus === "paid") {
          badgeClassName = "bg-success"
        } else if (paymentStatus === "unpaid") {
          badgeClassName = "bg-danger"
        } else if (paymentStatus === "partialpaid") {
          badgeClassName = ""
        } else if (
          paymentStatus === "complementary" ||
          paymentStatus === "Complementary"
        ) {
          badgeClassName = ""
        } else if (
          paymentStatus === "Exception" ||
          paymentStatus === "exception"
        ) {
          badgeClassName = ""
        } else {
          badgeClassName = "bg-danger"
        }
        const badgeStyle =
          paymentStatus === "partialpaid"
            ? { backgroundColor: "#f9851b", padding: "5px" }
            : paymentStatus === "complementary" ||
              paymentStatus === "Complementary"
              ? { backgroundColor: "#50a5f1", padding: "5px" }
              : paymentStatus === "Exception" || paymentStatus === "exception"
                ? { backgroundColor: "#d63afd", padding: "5px" }
                : { padding: "5px" }
        return (
          <div className="d-flex flex-row align-items-center">
            {!isEmpty(row.clearanceStatus) ? (
              <span
              className={`badge ${badgeClassName || ""}`}
              style={badgeStyle || {}}
            >
                {row.clearanceStatus}
              </span>
            ) : (
              "--"
            )}
          
          </div>
        )
      },
    },
  ]
  //Client columns
  //Data Table section
  const clientDataTable = !isEmpty(clientEvent_data)
    ? clientEvent_data.map((data, index) => {
      //////////////
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventName).join(",")
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventNo).join(",")
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? data.eventDetails
          .map((m) => moment(m.eventDate).format(dateFormat))
          .join(",")
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.startTime).join(",")
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.endTime).join(",")
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.venueLocation).join(",")
        : "--"
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadNo: data.leadNo,
        sNo: index + 1,
        deliverableCount: !isEmpty(data.deliverableDetails)
          ? data.deliverableDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        deliverableDetails: data.deliverableDetails,
        productName: data.productName ? data.productName : '--'
      }
    })
    : []

  //table columns
  const clientColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return <span>{row.leadNo}</span>
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "deliverableCount",
      text: "Deliverables",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.deliverableCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },

    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const clientExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Print Deliverable Code
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Product Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Delivery Address
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Assign Crm Employee
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Assigned Print Vendor
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Overall Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                No Of Sheet
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                No Of Wrapper Sheet
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Print File Link
              </th>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Additional Product Remarks
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Package Inclusion Number
              </th>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Print Process Status Name
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.deliverableDetails) &&
              row.deliverableDetails.length > 0 ? (
              row.deliverableDetails.map((data, index) => {
                const assignCrmEmployee = !isEmpty(data.assignCrmEmployee)
                  ? data.assignCrmEmployee.map((m) => m.name).join(",")
                  : "--"
                const assignedPrintVendor = !isEmpty(data.assignedPrintVendor)
                  ? data.assignedPrintVendor.map((m) => m.employeeName)
                  : "--"
                return (
                  <tr key={index}>
                    <td>
                      {data.printdeliverableCode
                        ? data.printdeliverableCode
                        : "--"}
                    </td>
                    <td>{data.productName ? data.productName : "--"}</td>
                    <td>{data.deliveryAddress ? data.deliveryAddress : "--"}</td>
                    <td>{assignCrmEmployee}</td>
                    <td>{assignedPrintVendor}</td>
                    <td>{data.overAllStatus ? data.overAllStatus : "--"}</td>
                    <td>{data.noOfSheet ? data.noOfSheet : "--"}</td>
                    <td>
                      {data.noOfWrapperSheet ? data.noOfWrapperSheet : "--"}
                    </td>
                    <td>{data.printFileLink ? data.printFileLink : "--"}</td>
                    <td>
                      {data.additionalProductRemarks
                        ? data.additionalProductRemarks
                        : "--"}
                    </td>
                    <td>
                      {data.packageInclusionNumber
                        ? data.packageInclusionNumber
                        : "--"}
                    </td>

                    <td>
                      {data.printProcessStatusName
                        ? data.printProcessStatusName
                        : "--"}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={10}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const clientOptions = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const [uploadModalInput, setUploadModalInput] = useState([])
  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  const uploadModalChange = async (e) => {
    if (e.target.files) {
      setUploadModalInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadModalInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadModalInput(teamUploadValue)
          }
        })
      }
    }
  }
  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }

  //Team assigne section
  const vendorEmployeeValue =
    vendorEmployee && vendorEmployee.map((m) => m.value)
  const vendorSubmit = () => {
    const vendor_details = {
      notes: teamData.note,
      attachments: uploadModalInput,
      vendorId: vendorEmployeeValue,
      printVendorAssignDetail: [
        {
          leadId: vendorAssignData.leadId,
          operationId: vendorAssignData.operationId,
        },
      ],
    }

    dispatch(printAction.assignVendor(vendor_details))
    setTimeout(() => {
      setProcessStatusModal(false)
      dispatch(printAction.loadPrint(searchValue))
      toast.success("Vendor Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const vendorMultipleEmployee =
    multiVendorEmployee && multiVendorEmployee.map((m) => m.value)
  const vendorMultipleSubmit = () => {
    const vendor_details = {
      notes: multiTeamData.note,
      attachments: multiTeamFile,
      vendorId: vendorMultipleEmployee,
      printVendorAssignDetail: vendorAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          operationId: data.operationId,
        }
      }),
    }
    dispatch(printAction.assignVendor(vendor_details))

    setTimeout(() => {
      dispatch(printAction.loadPrint(searchValue))
      toast.success("Vendor Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setVendorAssignDetails([])
      setMultiVendorModal(false)
    }, 1000)
  }

  //Attachment Modal start

  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }
      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)
    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      printAction.loadPrint({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        printProcessStatus: "PS74",
        PrintPlId: empId,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchProduct = productName && productName ? productName.value : ""
    var searchProductCategory = productCategoryName && productCategoryName ? productCategoryName.value : ""
    var searchClearance = clearanceStatus && clearanceStatus ? clearanceStatus.value : ""
    var searchCrm = crmName && crmName ? crmName.value : ""
    var searchIsPackageInclusion = isPackageInclusion && isPackageInclusion == true ? true : ""
    var searchFromDate =
      printData && printData.printAssignFromDate
        ? moment(printData.printAssignFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      printData && printData.printAssignToDate
        ? moment(printData.printAssignToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    searchvalue.PrintPlId = empId
    searchvalue.printProcessStatus = 'PS74'
    if (searchProduct) {
      searchvalue.productId = searchProduct
    }
    if (searchProductCategory) {
      searchvalue.productCategoryId = searchProductCategory
    }
    if (searchClearance) {
      searchvalue.paymentStatus = searchClearance
    }
    if (searchCrm) {
      searchvalue.crmPrintId = searchCrm
    }
    if (searchFromDate) {
      searchvalue.printAssignedFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.printAssignedToDate = searchToDate
    }
    if (searchIsPackageInclusion) {
      searchvalue.isPackageInclusion = searchIsPackageInclusion
    }

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_print_vendor_details_excel_export`, searchvalue)
      .then((response) => {
        const myWorksExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const plArray =
              !isEmpty(data.assignedPrintPl) &&
              data.assignedPrintPl.length > 0 &&
              data.assignedPrintPl
                .map((m) => {
                  const empName = !isEmpty(m)
                    ? `${m.empCode} - ${m.name}`
                    : ""
                  return empName
                })
                .filter(Boolean)
            const plName = plArray.length > 0 ? plArray.join(",") : "--"
            const plNameValue = JSON.stringify(plName).replace(/","/g, "\n")
            const printVendorArray =
              !isEmpty(data.assignedPrintVendor) &&
              data.assignedPrintVendor.length > 0 &&
              data.assignedPrintVendor
                .map((m) => {
                  const empName = !isEmpty(m)
                    ? `${m.printVendorCode} - ${m.printVendorName}`
                    : ""
                  return empName
                })
                .filter(Boolean)
            const printVendorName =
              printVendorArray.length > 0 ? printVendorArray.join(",") : ""
            const printVendorValue = JSON.stringify(printVendorName).replace(
              /","/g,
              "\n"
            )

            const groomName = JSON.stringify(data.groomName).replace(
              /","/g,
              "\n"
            )
            const brideName = JSON.stringify(data.brideName).replace(
              /","/g,
              "\n"
            )
            const eventDate = data && data.eventDetails.length > 0 ?
              data.eventDetails.map(m => moment(m.eventDate).format(dateFormat)).join(",")
              : "--"
            const crmName = data && !isEmpty(data.assignedCrmEmployee) ? data.assignedCrmEmployee.map(m => m.name).join(",") : "--"
            return {
              key: index,
              _id: data._id,
              sNo: index + 1,
              leadNo: data.leadNo,
              clientCode: data.clientCode ? data.clientCode : "--",
              clientName: data.clientName ? data.clientName : "--",
              groomName: groomName ? groomName : "--",
              brideName: brideName ? brideName : "--",
              crmName: crmName,
              productLeadName: plName ? plNameValue : "--",
              vendorName: printVendorName ? printVendorValue : "--",
              productName: data.productName ? data.productName : "--",
              overallStatus: data.overAllStatus ? data.overAllStatus : "--",
              operationStatus: data.PrintProcessStatusName
                ? data.PrintProcessStatusName
                : "--",
              eventDate: eventDate,
              applicableEvents: !isEmpty(data.eventDetails) ? data.eventDetails.map(m => m.eventName).join(",") : "--",
              clearanceStatus: data.clearanceStatusName ? data.clearanceStatusName : "--",
              printAssignDate: data.printAssignDate
                ? moment(data.printAssignDate).format(dateFormat)
                : "--",
              packageInclusionNumber: data.packageInclusionNumber
                ? data.packageInclusionNumber
                : "--",
              sheetCount: (data.sheetLength !== null && data.sheetLength !== undefined &&
                data.count !== null && data.count !== undefined) ?
                `${data.sheetLength}/${data.count}` :
                "--",
              printFileLink: data.printFileLink ? data.printFileLink : "--",
              deliveryAddress: data.deliveryAddress ? data.deliveryAddress : "--",
              productRemarks: data.productRemarks
                ? data.productRemarks
                : "--",
              printDeliverableCode: data.printDeliverableCode ? data.printDeliverableCode : "--",
              "noOfSheets": data.noOfSheet || "--",
              "noOfWrapperSheets": data.noOfWrapperSheet || "--",
              //"productRemarks": data.additionalProductRemarks || "--",
              "packageInclusionRemarks": data.packageInclusionRemarks || "--",
            }
          })
          : []

        setTimeout(() => {
          let headerData = ["SNo, Print Deliverable Code, Print Assign Date, Product Remarks, Product Name, Sheet/Count, No of Sheets, No Of Wrapper Sheets, CRM Name, Bride Name, Groom Name, Applicable Events, Event Date, Client Name, Lead No, Client Code, Print PL Name, Vendor Name, Package Inclusion Number, Package Inclusion Remarks, Print File Link, Delivery Address, Quantity, Deliverable Status, Overall Status, Clearance Status"]


          let usersCsv = myWorksExportDataTable.reduce((acc, user) => {
            const {
              sNo,
              printDeliverableCode,
              printAssignDate,
              productRemarks,
              productName,
              sheetCount,
              noOfSheets,
              noOfWrapperSheets,
              crmName,
              brideName,
              groomName,
              applicableEvents,
              eventDate,
              clientName,
              leadNo,
              clientCode,
              productLeadName,
              vendorName,
              pacakageInclusion,
              packageInclusionRemarks,
              printFileLink,
              deliveryAddress,
              quantity,
              operationStatus,
              overallStatus,
              clearanceStatus,
            } = user
            acc.push([
              sNo,
              printDeliverableCode,
              printAssignDate,
              productRemarks,
              productName,
              sheetCount,
              noOfSheets,
              noOfWrapperSheets,
              crmName,
              brideName,
              groomName,
              applicableEvents,
              eventDate,
              clientName,
              leadNo,
              clientCode,
              productLeadName,
              vendorName,
              pacakageInclusion,
              packageInclusionRemarks,
              printFileLink,
              deliveryAddress,
              quantity,
              operationStatus,
              overallStatus,
              clearanceStatus,
            ])
            return acc
          }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "PrintPlOnHold.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {teamSubmitButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiVendorModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Vendor Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          noDataIndication={"No Data Found..."}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: print_data.length,
    data:
      !isEmpty(print_data) && print_data.length > 0
        ? print_data.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)

    let result = !isEmpty(print_data) && print_data.length > 0 ? print_data : []
    if (
      !isEmpty(clearanceStatus) ||
      !isEmpty(crmName) ||
      !isEmpty(productCategoryName) ||
      !isEmpty(productName) ||
      !isEmpty(isPackageInclusion) ||
      !isEmpty(printData.printAssignFromDate) ||
      !isEmpty(printData.printAssignToDate)
    ) {
      var searchProduct = productName && productName ? productName.value : ""
      var searchProductCategory = productCategoryName && productCategoryName ? productCategoryName.value : ""
      var searchClearance = clearanceStatus && clearanceStatus ? clearanceStatus.value : ""
      var searchCrm = crmName && crmName ? crmName.value : ""
      var searchIsPackageInclusion = isPackageInclusion && isPackageInclusion == true ? true : ""
      var searchFromDate =
        printData && printData.printAssignFromDate
          ? moment(printData.printAssignFromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        printData && printData.printAssignToDate
          ? moment(printData.printAssignToDate).format("YYYY-MM-DD")
          : ""
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      searchvalue.printProcessStatus = 'PS74'
      searchvalue.PrintPlId = empId
      if (searchProduct) {
        searchvalue.productId = searchProduct
      }
      if (searchProductCategory) {
        searchvalue.productCategoryId = searchProductCategory
      }
      if (searchClearance) {
        searchvalue.paymentStatus = searchClearance
      }
      if (searchCrm) {
        searchvalue.crmPrintId = searchCrm
      }
      if (searchFromDate) {
        searchvalue.printAssignedFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.printAssignedToDate = searchToDate
      }
      if (searchIsPackageInclusion) {
        searchvalue.isPackageInclusion = searchIsPackageInclusion
      }

      setPageLoad(!pageLoad)

      setLoading(true)
      dispatch(printAction.loadPrint(searchvalue))
    } else {
      dispatch(printAction.loadPrint({
        page: page,
        limit: sizePerPage,
        printProcessStatus: "PS74",
        PrintPlId: empId,
      }))
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  const processSubmit = (e) => {
    e.preventDefault()
    const submitStatus = {
      operationId: updateProcess.operationId,
      mode: "PV",
      printProcessstatus: deliverableStatus.value,
      notes: processData.notes,
      attachment: operationAttachment,
    }
    dispatch(printAction.updateProcess(submitStatus))
    setTimeout(() => {
      dispatch(printAction.loadPrint(searchValue))
      setProcessStatusModal(false)
      toast.success("Print Process Status Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  //Columns data hisotry submit

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Crm Print"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"CRM Name"}>
                          {"CRM Name"}
                        </Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="agent"
                        key={agentKey}
                        items={recordsMetaData.employeeOptions}
                        value={crmName}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setCrmName(e)}
                        onChange={(e) => setCrmName(e.target.value)}
                        onClear={() => setCrmName([])}
                        placeholder="Enter CRM Name"
                        fuseOptions={{
                          keys: ["empCode", "label"]
                        }
                        } // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Product"}>
                          {"Product"}
                        </Label>
                      </div>

                      <Select
                        isClearable={true}
                        type="text"
                        name="productName"
                        value={productName}
                        onChange={(e) => setProductName(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-5">
                      <div className="d-flex flex-row">
                        {statusListEngage.map((status, index) => {
                          return (
                            <div className="d-flex flex-row" key={index}>
                              <Input
                                type="checkbox"
                                name="isPackageInclusion"
                                value={status.value}
                                checked={isPackageInclusion === status.value}
                                onChange={(e) =>
                                  handleStatusEngageChange(e, status.value)
                                }
                                className="font-size-15"
                              />
                              <Label
                                className="mx-2"
                                style={{ marginTop: "2px", fontSize: "12px" }}
                              >
                                {status.label}
                              </Label>
                            </div>
                          )
                        })}
                      </div></Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Clearance Status</Label>
                      <Select
                        isClearable={true}
                        type="text"
                        name="clearanceStatus"
                        value={clearanceStatus}
                        onChange={(e) => setClearanceStatus(e)}
                        options={[{ label: "Completed", value: "Completed" },
                        { label: "Partial Pending", value: "Partial_Pending" },
                        { label: "Pending", value: "Pending" },
                        { label: "Exception", value: "Exception" },
                        { label: "Complimentary", value: "Complimentary" },]
                        }
                        placeholder="Select Clearance Status"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Product Category</Label>

                      <Select
                        isClearable={true}
                        type="text"
                        name="productCategoryName"
                        value={productCategoryName}
                        onChange={(e) => setProductCategoryName(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productCategoryOptions : []
                        }
                        placeholder="Select Product Category"
                        classNamePrefix="select2-selection"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {" Print Assign From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="printAssignFromDate"
                        value={printData.printAssignFromDate}
                        max={printData.printAssignToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Print Assign To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="printAssignToDate"
                        value={printData.printAssignToDate}
                        min={printData.printAssignFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>


                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <RemotePagination
                  data={myWorksTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={
                    !isEmpty(print_data) ? print_data.totalDataCount : 0
                  }
                  onTableChange={handleTableChange}
                />
                {loading ? (
                  <Modal
                    show={loading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {btnLoading ? (
                  <Modal
                    show={btnLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {downloadLoading ? (
                  <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {columnModal && (
        <Modal size="xl" show={columnModal}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Edit Columns
            <span>
              <i
                className="fa fa-times quote-close"
                aria-hidden="true"
                onClick={() => setColumnModal(false)}
              ></i>
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <div>
                <Input
                  type="checkbox"
                  checked={selectedColumns.length === columns.length}
                  onChange={(e) => handleSelectAllChange(e)}
                  style={{ width: "15px", height: "15px" }}
                />
                <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                  Select All
                </Label>
              </div>
            </Row>
            <Row>
              <Col sm="12" md="6" lg="6" className="ml-4">
                {oddColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
              <Col sm="12" md="6" lg="6">
                {evenColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <p
              className="text-decoration-underline text-info"
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={handleRestoreToDefault}
            >
              Restore To Default
            </p>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setColumnModal(false)
                setSelectedColumns(selectColumn)
              }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-success"
              onClick={() => handleSaveColumns()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {processStatusModal && (
        <Modal size="xl" show={processStatusModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Status
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label
                    className={"form-label"}
                    htmlFor={"Deliverable Status"}
                  >
                    {"Deliverable Status"}
                  </Label>
                </div>
                <Select
                  type="text"
                  name="deliverableStatus"
                  value={deliverableStatus}
                  onChange={(e) => setDeliverableStatus(e)}
                  placeholder="Select Deliverable Status"
                  options={deliverableStatusOptions}
                  classNamePrefix="select2-selection"
                />
              </Col>

              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="notes"
                  value={processData.notes}
                  onChange={(e) => handleNotesChange(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Input
                  type="file"
                  name="operationAttachment"
                  onChange={(e) => operationAttachmentChange(e)}
                  placeholder="Attach the files"
                  multiple
                />
              </Col>
              {deliverableStatus.value == "PS49" && isEmpty(updateProcess.pvAssign) ? (
                <Row className="mt-3">
                  <Col md="4" lg="4" xl="4" sm="12">
                    <div className="d-flex justify-content-between">
                      <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                        {"Vendor"}
                      </Label>
                    </div>

                    <Select
                      isMulti
                      type="text"
                      name="vendorEmployee"
                      value={vendorEmployee}
                      onChange={(e) => setVendorEmployee(e)}
                      options={vendorOptions}
                      placeholder="Select Vendor"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col md="4" lg="4" xl="4" sm="12">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"} htmlFor={"Notes"}>
                        {"Notes"}
                      </Label>
                    </div>
                    <Input
                      type="textarea"
                      name="note"
                      value={teamData.note}
                      onChange={(e) => handleTeam(e)}
                      placeholder="Enter Notes"
                    />
                  </Col>
                  <Col lg="4" md="4" sm="12" xs="12">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"}>
                        {"Attachment (JPG/PNG)"}
                      </Label>
                    </div>
                    <Button className=" btn btn-warning  position-relative fs-5">
                      <i className="fas fa-laptop"></i>

                      <Input
                        type="file"
                        name="uploadModalInput"
                        accept="application/pdf, audio/mp3 , image/jpeg"
                        // id="upload-btn"
                        multiple
                        onChange={(e) => uploadModalChange(e)}
                        style={{
                          position: "absolute",
                          fontSize: "50px",
                          opacity: 0,
                          right: 0,
                          top: 0,
                        }}
                      />
                      <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                        {fileLength ? fileLength : 0}
                      </span>
                    </Button>
                    <div className="text-decoration-underline text-danger">
                      {fileName ? fileName : ""}
                    </div>
                  </Col>
                </Row>
              ) : (" ")

              }
            </Row>
            <Row className="quote-head-content">
              <Col md="6" lg="6" sm="12">
                <p className="quote-head">Process Status History</p>
              </Col>
            </Row>
            <Row>
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mode</th>
                    <th>Employee Name</th>
                    <th>Deliverable Status</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(processHistoryDetails) &&
                    processHistoryDetails.length > 0 ? (
                    processHistoryDetails.map((data, index) => {
                      const colorCode =
                        !isEmpty(recordsMetaData) &&
                          recordsMetaData.processStatusOptions &&
                          recordsMetaData.processStatusOptions.length > 0
                          ? recordsMetaData.processStatusOptions.find(
                            (_) => _.value === data.printProcessstatus
                          )?.colorCode
                          : ""

                      const createdOn = !isEmpty(data.createdOn)
                        ? moment
                          .utc(data.createdOn)
                          .format(`${dateFormat} ${"hh:mm A"}`)
                        : "--"
                      const empName =
                        data.employeName && data.employeCode
                          ? data.employeCode + "-" + data.employeName
                          : "--"
                      const attachment = !isEmpty(data.attachment)
                        ? data.attachment.map((m) => m).join()
                        : ""
                      const attachExtension = !isEmpty(attachment)
                        ? attachment.split(".").pop()
                        : ""
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.mode ? data.mode : "--"}</td>
                          <td>{empName}</td>
                          <td>
                            {data.printProcessStatusName ? (
                              <button
                                style={{
                                  background: colorCode,
                                  border: "none",
                                  cursor: "pointer",
                                  color: "white",
                                  padding: "4px 8px",
                                  borderRadius: "3px",
                                }}
                              >
                                {data.printProcessStatusName}
                              </button>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>{data.notes ? data.notes : "--"}</td>
                          <td>
                            {" "}
                            {(attachment && attachExtension === "jpeg") ||
                              (attachment && attachExtension === "jpg") ||
                              (attachment && attachExtension === "png") ? (
                              <a
                                onClick={() =>
                                  window.open(attachment, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            ) : (attachment && attachExtension === "mp3") ||
                              (attachment && attachExtension === "m4a") ||
                              (attachment && attachExtension === "mp4") ? (
                              <a href={attachment}>
                                <audio controls>
                                  <source src={attachment} type="audio/mpeg" />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>
                            {data.createdByName ? data.createdByName : "--"}
                          </td>
                          <td>{createdOn}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td className="text-align-center" colSpan={8}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setProcessStatusModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="secondary"
              className={"btn btn-success"}
              data-bs-dismiss="modal"
              onClick={(e) => {
                if (deliverableStatus.value == "PS49" && isEmpty(updateProcess.pvAssign)) {
                  vendorSubmit()
                } else {
                  processSubmit(e)
                }


              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {/* {historyModal && (
                <Modal size="xl" show={historyModal}>
                    <Modal.Header
                        style={{
                            backgroundColor: "#E40D8C",
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "600",
                        }}
                    >
                        Assigned History
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mt-3">
                            <Table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Type</th>
                                        <th>Employee Name</th>
                                        <th>Notes</th>
                                        <th>Attachment</th>
                                        <th>Created On</th>
                                        <th>Created By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!isEmpty(historyDetails) &&
                                        historyDetails.length > 0 ? (
                                        historyDetails.map((data, index) => {
                                            const employeeName =
                                                data.assignPrintPl !== undefined && !isEmpty(data.assignPrintPl) &&
                                                    !isEmpty(data.assignPrintPl[0].employeeId)
                                                    ? data.assignPrintPl[0].employeeId.map((m) => `${m.empCode} - ${m.name}`).join()
                                                    : data.assignedPrintVendor !== undefined &&
                                                        !isEmpty(data.assignedPrintVendor) &&
                                                        !isEmpty(data.assignedPrintVendor[0].vendorId)
                                                        ? data.assignedPrintVendor[0].vendorId
                                                            .map((m) => `${m.printVendorCode} - ${m.printVendorName}`)
                                                            .join()
                                                        : data.assignCrmEmployee !== undefined &&
                                                            !isEmpty(data.assignCrmEmployee) &&
                                                            !isEmpty(data.assignCrmEmployee[0].employeeId)
                                                            ? data.assignCrmEmployee[0].employeeId
                                                                .map((m) => `${m.empCode} - ${m.name}`)
                                                                .join()
                                                            : "--"
                                            const typeName = data.assignPrintPl
                                                ? "PRINTPL"
                                                : data.assignedPrintVendor
                                                    ? "PRINTVENDOR"
                                                    : data.assignCrmEmployee
                                                        ? "CRM"
                                                        : "--"
                                            const notes = data.assignPrintPl !== undefined && !isEmpty(data.assignPrintPl) &&
                                                data.assignPrintPl[0].notes
                                                ? data.assignPrintPl[0].notes
                                                : data.assignedPrintVendor !== undefined &&
                                                    !isEmpty(data.assignedPrintVendor) &&
                                                    data.assignedPrintVendor[0].notes
                                                    ? data.assignedPrintVendor[0].notes
                                                    : data.assignCrmEmployee !== undefined &&
                                                        !isEmpty(data.assignCrmEmployee) &&
                                                        data.assignCrmEmployee[0].notes
                                                        ? data.assignCrmEmployee[0].notes
                                                        : "--"
                                            const createdOn = data.assignPrintPl !== undefined && !isEmpty(data.assignPrintPl)
                                                ? moment.utc(data.assignPrintPl[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                                                : data.assignedPrintVendor !== undefined &&
                                                    !isEmpty(data.assignedPrintVendor)
                                                    ? moment.utc(data.assignedPrintVendor[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                                                    : data.assignCrmEmployee !== undefined &&
                                                        !isEmpty(data.assignCrmEmployee)
                                                        ? moment.utc(data.assignCrmEmployee[0].createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                                                        : "--"
                                            const createdBy = data.assignPrintPl !== undefined && !isEmpty(data.assignPrintPl)
                                                ? data.assignPrintPl[0].createdByName
                                                : data.assignedPrintVendor !== undefined &&
                                                    !isEmpty(data.assignedPrintVendor)
                                                    ? data.assignedPrintVendor[0].createdByName
                                                    : data.assignCrmEmployee !== undefined &&
                                                        !isEmpty(data.assignCrmEmployee)
                                                        ? data.assignCrmEmployee[0].createdByName
                                                        : "--"
                                            const attachment = data.assignPrintPl !== undefined && !isEmpty(data.assignPrintPl)
                                                ? data.assignPrintPl[0].attachments
                                                : data.assignedPrintVendor !== undefined &&
                                                    !isEmpty(data.assignedPrintVendor)
                                                    ? data.assignedPrintVendor[0].attachments
                                                    : data.assignCrmEmployee !== undefined &&
                                                        !isEmpty(data.assignCrmEmployee)
                                                        ? data.assignCrmEmployee[0].attachments
                                                        : "--"
                                            const attachmentValue = !isEmpty(attachment) ? attachment[0] : []
                                            const splitAttach = !isEmpty(attachmentValue)
                                                ? attachmentValue.split(".")
                                                : ""
                                            const attachExtension = !isEmpty(splitAttach) ? splitAttach.pop() : ""
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{typeName}</td>
                                                    <td>{employeeName}</td>
                                                    <td>{notes}</td>
                                                    <td> {(attachmentValue && attachExtension === "jpeg") ||
                                                        (attachmentValue && attachExtension === "jpg") ||
                                                        (attachmentValue && attachExtension === "png") ? (
                                                        <a onClick={() => window.open(attachmentValue, "_blank")}>
                                                            <span
                                                                style={{
                                                                    textDecoration: "underline",
                                                                    color: "#E40D8C",
                                                                }}
                                                            >
                                                                View
                                                            </span>
                                                        </a>
                                                    ) : (attachmentValue && attachExtension === "mp3") ||
                                                        (attachmentValue && attachExtension === "m4a") ||
                                                        (attachmentValue && attachExtension === "mp4") ? (
                                                        <a href={attachmentValue}>
                                                            <audio controls>
                                                                <source src={attachmentValue} type="audio/mpeg" />
                                                                Your browser does not support the audio element.
                                                            </audio>
                                                        </a>
                                                    ) : (
                                                        "--"
                                                    )}</td>
                                                    <td>{createdOn}</td>
                                                    <td>{createdBy}</td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr key={0}>
                                            <td className="text-align-center" colSpan={7}>
                                                No Records Found...
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                            onClick={() => setHistoryModal(false)}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )} */}
      {clientEventModal && (
        <Modal size="xl" show={clientEventModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Event
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="12" lg="12" xl="12" className="mt-3">
                <PaginationProvider
                  pagination={paginationFactory(clientOptions)}
                  keyField="index"
                  columns={clientColumns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="index"
                      data={clientDataTable}
                      columns={clientColumns}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row  ">
                              <Col>
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  keyField="index"
                                  expandRow={clientExpandRow}
                                  columns={clientColumns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setClientEventModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {vendorAssignModal && (
        <Modal size="xl" show={vendorAssignModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Vendor
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Vendor"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="vendorEmployee"
                  value={vendorEmployee}
                  onChange={(e) => setVendorEmployee(e)}
                  options={vendorOptions}
                  placeholder="Select Vendor"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={teamData.note}
                  onChange={(e) => handleTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="uploadModalInput"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => uploadModalChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {fileLength ? fileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {fileName ? fileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setVendorAssignModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                setVendorAssignModal(false)
                vendorSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {multiVendorModal && (
        <Modal size="xl" show={multiVendorModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Vendor
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Vendor"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="multiVendorEmployee"
                  value={multiVendorEmployee}
                  onChange={(e) => setMultiVendorEmployee(e)}
                  options={vendorOptions}
                  placeholder="Select Vendor"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={multiTeamData.note}
                  onChange={(e) => handleMultiTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="multiTeamFile"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => multiTeamChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {teamFileLength ? teamFileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {teamFileName ? teamFileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setMultiVendorModal(false)
                setVendorAssignDetails([])
              }}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                vendorMultipleSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
PrintPlOnHold.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PrintPlOnHold)
)
